import { render, staticRenderFns } from "./ReturnErrorView.vue?vue&type=template&id=04702cc2&"
import script from "./ReturnErrorView.vue?vue&type=script&lang=ts&"
export * from "./ReturnErrorView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReturnErrorView.vue"
export default component.exports